import React, { useState, useEffect, useCallback } from 'react';
import validationAuth from '../../validationAuth';
import axios from 'axios';
import {
    Container, List, ListItem, ListItemText, ListItemSecondaryAction,
    Box, Button, IconButton, ListItemIcon, Typography, FormControl, Select, MenuItem,
} from '@mui/material';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
//import MenuIcon from '@mui/icons-material/Menu';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AlertForConfirm from '../../components/alertForConfirm';
import * as common from '../../commons/common';
import { useNavigate } from 'react-router-dom';
import checkerListMenuIcon from '../../images/checker_list_menu_icon.png';

//점검목록 - 작성 tab
const ToRegisterList = () => {
    const [items, setItems] = useState([]);
    const [facilityTypes, setFacilityTypes] = useState([]);
    const [selectedFacilityType, setSelectedFacilityType] = useState('');
    const [isOpenAlertQrFacility, setIsOpenAlertQrFacility] = useState(false); //점검항목 삭제 alert
    const navigate = useNavigate();

    useEffect(() => {
        fetchFacilityTypes();
        fetchItems();
    }, []);

    useEffect(() => {
        fetchItems();
    }, [selectedFacilityType])

    useEffect(() => {
        if (facilityTypes.length > 0) {
            setSelectedFacilityType(String(facilityTypes[0].facilityTypeId));
        }
    }, [facilityTypes]);

    // 점검 목록 가져오기
    const fetchItems = async () => {
        const url = `${common.getApiUrl()}/checker`;
        const token = localStorage.getItem('access_token');

        try {
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                params: {
                    facilityTypeId: selectedFacilityType === '0' ? '' : selectedFacilityType
                }
            });
            if (response.data && Array.isArray(response.data)) {
                const fetchedItems = response.data.map(item => ({
                    id: item.facilityId.toString(),
                    title: item.facilityNm,
                    facilityTypeNm: `${item.facilityTypeNm || ''}`,
                    qrYn: item.qrYn || 'N',
                    completeCnt: item.completeCnt || 0
                }));

                // 저장된 순서 복원
                const savedOrder = JSON.parse(localStorage.getItem('itemOrder') || '[]');
                let orderedItems = fetchedItems;

                if (savedOrder.length > 0) {
                    const orderedFromStorage = [];
                    const unorderedItems = [...fetchedItems];

                    savedOrder.forEach(savedId => {
                        const foundIndex = unorderedItems.findIndex(item => item.id === savedId);
                        if (foundIndex !== -1) {
                            orderedFromStorage.push(unorderedItems.splice(foundIndex, 1)[0]);
                        }
                    });

                    orderedItems = [...orderedFromStorage, ...unorderedItems];
                }

                setItems(orderedItems);
            }
        } catch (error) {
            common.handleApiError(error);
        }
    };

    // 시설 유형 목록 가져오기
    const fetchFacilityTypes = async () => {
        const url = `${common.getApiUrl()}/checker/facilityType`;
        const token = localStorage.getItem('access_token');

        try {
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            if (response.data && Array.isArray(response.data)) {
                const updatedFacilityTypes = [
                    {
                        facilityTypeId: '0',
                        facilityTypeNm: "전체"
                    },
                    ...response.data.map(type => ({
                        ...type,
                        facilityTypeId: String(type.facilityTypeId)
                    }))
                ];
                setFacilityTypes(updatedFacilityTypes);
            }
        } catch (error) {
            common.handleApiError(error);
        }
    };

    // 드래그 앤 드롭 종료 처리
    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }

        const newList = Array.from(items);
        const [removed] = newList.splice(result.source.index, 1);
        newList.splice(result.destination.index, 0, removed);

        setItems(newList);

        // 로컬스토리지에 순서 저장
        localStorage.setItem('itemOrder', JSON.stringify(newList.map(item => item.id)));
    };

    const handleItemClick = ((event, item) => {
        event.preventDefault();
        if (item.qrYn === 'N') {
            navigate(`/checker/register-check/${item.id}`, { state: { facilityId: item.id, facilityName: item.title } });
        } else {
            setIsOpenAlertQrFacility(true);
        }
    })

    const handleAlertClose = () => {
        setIsOpenAlertQrFacility(false)
    }

    const handleFacilityTypeChange = (event) => {
        setSelectedFacilityType(event.target.value);
    };

    return (
        <>
            <Container
                maxWidth="false"
                sx={{
                    width: '100%',
                    mx: 'auto',
                    pt: 2,
                    backgroundColor: 'var(--main-white-color)',
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <FormControl fullWidth sx={{ mb: 1, mt: 1, position: 'relative' }}>
                    <Select
                        id="select"
                        value={selectedFacilityType}
                        onChange={handleFacilityTypeChange}
                        IconComponent={ExpandMoreIcon}
                        displayEmpty
                        sx={{
                            borderRadius: '22px',
                            cursor: 'pointer',
                            backgroundColor: 'white',
                            height: '45px',
                            display: 'flex',
                            alignItems: 'center',
                            color: '#807C7C',
                            '& .MuiSelect-select': {
                                display: 'flex',
                                alignItems: 'center',
                                padding: '0 14px 0 20px',
                                height: '100%',
                            },
                            '& .MuiSelect-icon': {
                                right: '20px'
                            },
                        }}
                    >
                        {facilityTypes.length > 0 && facilityTypes.map((type) => (
                            <MenuItem key={type.facilityTypeId} value={String(type.facilityTypeId)}>
                                <Typography sx={{ marginLeft: '5px', color: '#807C7C' }}>{type.facilityTypeNm}</Typography>
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <Box sx={{ flexGrow: 1 }}>
                    <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="droppable-list">
                            {(provided) => (
                                <List
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                    sx={{
                                        width: '100%',
                                        paddingTop: 1,
                                        paddingBottom: 1,
                                        backgroundColor: 'transparent',
                                    }}
                                >
                                    {items.map((item, index) => (
                                        <Draggable key={item.id} draggableId={item.id} index={index}>
                                            {(provided, snapshot) => (
                                                <Box
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    sx={{
                                                        mb: 1.0,
                                                        backgroundColor: 'white',
                                                        borderRadius: '12px',
                                                        overflow: 'hidden',
                                                        opacity: snapshot.isDragging ? 0.8 : 1,
                                                        transform: snapshot.isDragging ? 'rotate(2deg)' : 'none',
                                                        transition: 'opacity 0.2s ease, transform 0.2s ease',
                                                    }}
                                                >
                                                    <ListItem
                                                        sx={{
                                                            display: 'flex',
                                                            width: '100%',
                                                            minHeight: '80px',
                                                            padding: '4px 10px 4px 10px',
                                                            boxShadow: 'none',
                                                            transition: "background-color 0.2s ease",
                                                            alignItems: 'center',
                                                        }}
                                                    >
                                                        <ListItemIcon
                                                            sx={{
                                                                minWidth: 'auto',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                            }}
                                                        >
                                                            <Box
                                                                {...provided.dragHandleProps}
                                                                sx={{
                                                                    cursor: 'grab',
                                                                    opacity: 0.7,
                                                                    padding: '8px',
                                                                    marginRight: '12px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    borderRadius: '4px',
                                                                    '&:active': {
                                                                        cursor: 'grabbing',
                                                                    },
                                                                    '&:hover': {
                                                                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                                                    }
                                                                }}
                                                            >
                                                                <img
                                                                    src={checkerListMenuIcon}
                                                                    alt="menu"
                                                                    style={{
                                                                        width: '20px',
                                                                        height: '20px',
                                                                        objectFit: 'contain',
                                                                        pointerEvents: 'none',
                                                                    }}
                                                                />
                                                            </Box>
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            sx={{
                                                                flex: '1',
                                                                marginRight: '16px',
                                                            }}
                                                            primary={item.title}
                                                            secondary={
                                                                <Box sx={{
                                                                    display: 'inline-block',
                                                                    padding: '1px 4px',
                                                                    marginTop: '8px',
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '4px',
                                                                    fontSize: '0.7rem',
                                                                    wordBreak: 'break-all',
                                                                    whiteSpace: 'normal',
                                                                    lineHeight: 'normal',
                                                                    fontWeight: 400
                                                                }}>
                                                                    {item.facilityTypeNm}
                                                                </Box>
                                                            }
                                                            primaryTypographyProps={{
                                                                fontSize: '1.2rem',
                                                                fontWeight: 'bold',
                                                                lineHeight: 1.1
                                                            }}
                                                        />
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                flexShrink: 0,
                                                                gap: '8px'
                                                            }}
                                                        >
                                                            <Typography
                                                                sx={{
                                                                    color: item.completeCnt === 0 ? '#5B5B5B' : '#74B4E8',
                                                                    fontSize: '0.8rem',
                                                                    fontWeight: 'bold',
                                                                    marginRight: '8px'
                                                                }}
                                                            >
                                                                {item.completeCnt}
                                                            </Typography>
                                                            <Button
                                                                variant="contained"
                                                                sx={{
                                                                    backgroundColor: 'var(--main-softblue-color)',
                                                                    color: 'white',
                                                                    borderRadius: '16px',
                                                                    padding: '4px 15px',
                                                                    fontSize: '0.8rem',
                                                                    boxShadow: 'none',
                                                                    marginRight: '10px',
                                                                    minWidth: '80px',
                                                                    '&:hover': {
                                                                        backgroundColor: item.complete ? '#ACB7C7' : '#429BE1',
                                                                        boxShadow: 'none',
                                                                    },
                                                                    '&:active': {
                                                                        boxShadow: 'none',
                                                                    },
                                                                }}
                                                                onClick={(event) => handleItemClick(event, item)}
                                                            >
                                                                작성하기
                                                            </Button>
                                                        </Box>
                                                    </ListItem>
                                                </Box>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </List>
                            )}
                        </Droppable>
                    </DragDropContext>
                </Box>
            </Container>
            <AlertForConfirm
                open={isOpenAlertQrFacility}
                onClose={handleAlertClose}
                onConfirm={handleAlertClose}
                showCancel={false}
                contentText="해당 시설은 QR접속 점검만 가능합니다."
            />
        </>
    );
}
export default validationAuth(ToRegisterList);